import Portfolio from "../../componets/Portfolio";

export default function Section1() {
  return (
    <div className="w-full h-[30vh] xl:h-[60vh] Section1">
      <Portfolio
        bgImage={"assets/bg-image-va.jpg"}
        objectPosition={"center-center"}
        customer={false}
        altText="Virtual Assistant Background Image"
      />
    </div>
  );
}
